import React from "react";
import { X, Download } from "lucide-react";
import { Button } from "./ui/button";
import { toast } from "sonner";

export default function ImageViewer({ imageUrl, onClose }) {
  const handleSave = async () => {
    try {
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `zd-golf-${Date.now()}.jpg`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      toast.success("Изображение сохранено");
    } catch (error) {
      toast.error("Ошибка сохранения");
    }
  };

  return (
    <div 
      className="image-viewer" 
      onClick={onClose}
      data-testid="image-viewer"
    >
      <div className="absolute top-4 right-4 left-4 flex justify-between z-10 safe-area-inset-top">
        <Button
          variant="ghost"
          size="icon"
          onClick={onClose}
          className="rounded-full bg-black/20 hover:bg-black/40 text-white"
          data-testid="close-viewer-btn"
        >
          <X className="w-6 h-6" />
        </Button>
        <Button
          variant="ghost"
          size="icon"
          onClick={(e) => {
            e.stopPropagation();
            handleSave();
          }}
          className="rounded-full bg-black/20 hover:bg-black/40 text-white"
          data-testid="save-image-btn"
        >
          <Download className="w-6 h-6" />
        </Button>
      </div>
      <img
        src={imageUrl}
        alt="Full size"
        className="max-w-full max-h-full object-contain"
        onClick={(e) => e.stopPropagation()}
      />
    </div>
  );
}
